import styledComp from 'styled-components';
import { Styling } from '../../../../constants';

export const FormRow = styledComp.div`
  margin: ${Styling.DEFAULT_SPACING}px auto ${Styling.DEFAULT_SPACING_HALVED}px auto !important;
  padding: 0 ${Styling.DEFAULT_SPACING_DOUBLED}px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  justify-items: center;
`;

export const FormLabel = styledComp.span`
  display: inline-flex;
  align-items: center;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const FormSpacer = styledComp.div`
padding: 0 0 ${Styling.DEFAULT_SPACING}px 0;
`;
